module.exports = __webpack_public_path__ + "img/data1-2.67978002.png";